import { useEffect, useState } from "react";
import { HiMenu, HiX } from "react-icons/hi";

export default function Header() {
    const [scrolled, setScrolled] = useState(false);
    const [menuOpen, setMenuOpen] = useState(false);
    const [pathname, setPathname] = useState(window.location.pathname);

    useEffect(() => {
        const handleScroll = () => {
            setScrolled(window.scrollY > 0);
        };
        window.addEventListener("scroll", handleScroll);

        const handlePathChange = () => {
            setPathname(window.location.pathname);
        };
        window.addEventListener("popstate", handlePathChange);

        return () => {
            window.removeEventListener("scroll", handleScroll);
            window.removeEventListener("popstate", handlePathChange);
        };
    }, []);

    const navLinks = [
        { href: "/", label: "Home" },
        { href: "/estoque", label: "Estoque" },
        { href: "/financiamento", label: "Financiamento" },
        { href: "/contato", label: "Contato" },
    ];

    return (
        <header
            className={`px-6 py-4 fixed w-full top-0 left-0 z-50 transition-colors duration-300 bg-black shadow flex items-center ${scrolled ? "scrolled" : ""}`}
        >
            <div className="flex items-center justify-between w-full">
                <a href="/">
                    <img
                        src="/logo.png"
                        alt="Logo do SP Car's"
                        width={150}
                        height={50}
                    />
                </a>

                <div className="md:hidden">
                    <button
                        onClick={() => setMenuOpen(!menuOpen)}
                        className="text-3xl text-withe transition-colors duration-300"
                    >
                        {menuOpen ? <HiX /> : <HiMenu />}
                    </button>
                </div>

                <nav className="hidden md:flex">
                    <ul className="flex items-center gap-6 font-semibold text-white">
                        {navLinks.map((link) => (
                            <li key={link.href}>
                                <a
                                    href={link.href}
                                    className={`relative pb-1 transition-colors ${
                                        pathname === link.href
                                            ? "after:content-[''] after:absolute after:left-0 after:right-0 after:-bottom-0.5 after:h-1 after:bg-[#CFAD5D] after:rounded"
                                            : ""
                                    }`}
                                >
                                    {link.label}
                                </a>
                            </li>
                        ))}
                    </ul>
                </nav>
            </div>

            {menuOpen && (
                <div className="absolute top-full left-0 w-full bg-black shadow-md md:hidden">
                    <ul className="flex flex-col items-start px-6 py-4 text-white font-semibold gap-4">
                        {navLinks.map((link) => (
                            <li key={link.href}>
                                <a
                                    href={link.href}
                                    onClick={() => setMenuOpen(false)}
                                    className={`block w-full py-2 border-b border-[#CFAD5D] ${
                                        pathname === link.href ? "text-[#CFAD5D]" : ""
                                    }`}
                                >
                                    {link.label}
                                </a>
                            </li>
                        ))}
                    </ul>
                </div>
            )}
        </header>
    );
}
